// src\app\pages\PersonSearchPage.jsx
import { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"

import { analyseUrl } from "../companiesHouse/pageFunctions/commonFunctions"
import { actions as lseActions } from '../../modules/lseModule'

class PersonSearchPage extends Component {

  componentDidMount = () => {
    // console.log("PersonSearchPage componentDidMount this.props:", this.props)
    const urlProps = analyseUrl(this.props)
    this.props.lse.getPerson({ ...this.props, ...urlProps })
  }

  render() {
    return null
  }
}

const mapStateToProps = ({ common }) => {
  return {
    checkboxes: common.checkboxes,
    nexusView: common.nexusView,
    radio: common.radio,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    lse: bindActionCreators(lseActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps,)(PersonSearchPage)

